module.exports = __webpack_public_path__ + "static/WorkSans-Bold-f051cc0ed2761378e886727284cf3c05.ttf";